import styled, { css } from 'styled-components';

export const Wrapper = styled.span`
  display: flex;
  align-items: center;
  user-select: none;
`;

export const Text = styled.p`
  margin-right: 5px;
  color: ${({ theme }) => theme.colors.white100};
  font-size: ${({ theme }) => theme.fontSize.B3};
  font-weight: 700;
`;

export const ButtonWrapper = styled.div`
  height: 24px;
  position: relative;
  display: inline-block;
  vertical-align: top;
`;

export const Label = styled.label<{ checked?: boolean }>`
  position: relative;
  width: 44px;
  height: 24px;
  display: block;
  background-color: ${({ theme }) => theme.colors.gray700};
  border-radius: 12px;
  margin-bottom: 0;
  cursor: pointer;

  &::before {
    content: '';
    display: block;
    position: absolute;
    top: 2px;
    left: 2px;
    width: 20px;
    height: 20px;
    background-color: #fff;
    background-repeat: no-repeat;
    background-position: center;
    background-image: url('/images/ico-switch.svg');
    border-radius: 50%;
    transition: left 0.1s;
  }

  ${({ checked }) =>
    checked &&
    css`
      background-color: ${({ theme }) => theme.colors.magenta700};
      &::before {
        left: 22px;
        background-image: url('/images/ico-switch-checked.svg');
      }
    `}
`;

export const Input = styled.input`
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  visibility: hidden;

  &:disabled + ${Label} {
    opacity: 0.3;
  }
`;
